export default "__VITE_ASSET__BvGMgshw__"